import React from 'react';
import PropTypes from 'prop-types';

import Loader from '../Loader';
import ProtectedMedia from '../../Molecules/ProtectedMedia';

import MediaError from '../../../assets/images/media_error.jpg';
import {
	preventMediaContextMenu,
	preventMediaDrag,
	subscribeMediaProtection,
	subscribeObscured,
} from '../../../shared/MediaProtection';

import './index.sass';

class Photo extends React.Component {
	state = {
		loading: true,
		cache: null,
		protectionHidden: false,
		obscuredHidden: false,
	}

	componentDidMount() {
		this.unsubscribeProtection = subscribeMediaProtection((active) => {
			this.syncMediaHidden({ protectionActive: active });
		});
		this.unsubscribeObscured = subscribeObscured((active) => {
			this.syncMediaHidden({ obscuredActive: active });
		});
	}

	componentWillUnmount() {
		if (this.unsubscribeProtection) {
			this.unsubscribeProtection();
		}
		if (this.unsubscribeObscured) {
			this.unsubscribeObscured();
		}
	}

	syncMediaHidden({ protectionActive, obscuredActive } = {}) {
		const { protectedMedia } = this.props;
		const nextState = {};

		if (typeof protectionActive === 'boolean') {
			nextState.protectionHidden = Boolean(protectedMedia && protectionActive);
		}

		if (typeof obscuredActive === 'boolean') {
			nextState.obscuredHidden = Boolean(protectedMedia && obscuredActive);
		}

		this.setState(nextState);
	}

	componentDidUpdate(prevProps) {
		const { id: lastId, avoidCache: lastAvoidCache, protectedMedia: lastProtectedMedia } = prevProps
		const { id, avoidCache, protectedMedia } = this.props
		const { loading } = this.state

		if (lastProtectedMedia !== protectedMedia && !protectedMedia) {
			this.setState({ protectionHidden: false, obscuredHidden: false });
		}

		if (lastId && lastId !== id && !loading) {
			this.setState({
				loading: true
			})
		}

		if (!lastAvoidCache && avoidCache) {
			this.setState({
				cache: new Date().getTime()
			})
		}
	}

	render() {
		const { className, id, filename, alt, type, hasBorder, avoidCache, isExtra, mediaType, protectedMedia } = this.props;
		const { loading, cache, protectionHidden, obscuredHidden } = this.state;
		let photoSource = `${process.env.ROVERPIX_API}/api/v1/${isExtra ? 'extra' : mediaType}/download/${id}/${filename}?size=${type}`;

		if (avoidCache) photoSource = `${photoSource}&cache=${cache}`

		const mediaHidden = protectionHidden || obscuredHidden;
		const showLoader = loading || mediaHidden;

		const image = (
			<img
				className={`Photo Photo--${type} ${className} ${hasBorder ? 'Photo--hasBorder' : ''} ${loading ? 'Photo--loading' : ''} ${mediaHidden ? 'Photo--protection-hidden' : ''}`}
				src={mediaHidden ? undefined : photoSource}
				alt={alt}
				draggable={false}
				onContextMenu={preventMediaContextMenu}
				onDragStart={preventMediaDrag}
				onLoad={() => this.setState({ loading: false })}
				onError={({ currentTarget }) => {
					if (mediaHidden) {
						return;
					}

					this.setState({loading: false});
					currentTarget.onerror = null;
					currentTarget.src = MediaError;
				}}
			/>
		);

		return (
			<ProtectedMedia enabled={protectedMedia}>
				{showLoader && (
					<Loader size={type === 'thumb' ? 'small' : 'medium'}/>
				)}
				{image}
			</ProtectedMedia>
		)
	}
}

Photo.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string.isRequired,
	filename: PropTypes.string.isRequired,
	alt: PropTypes.string,
	mediaType: PropTypes.oneOf([
		'photo', 'video'
	]),
	type: PropTypes.oneOf([
		'thumb', 'preview'
	]),
	hasBorder: PropTypes.bool,
	avoidCache: PropTypes.bool,
	isExtra: PropTypes.bool,
	protectedMedia: PropTypes.bool,
};

Photo.defaultProps = {
	className: '',
	alt: 'Customer photo',
	type: 'thumb',
	hasBorder: false,
	avoidCache: false,
	isExtra: false,
	mediaType: 'photo',
	protectedMedia: false,
};

export default Photo;
